import { Pipe, PipeTransform } from '@angular/core';

/**
 * Convert Resource to Json.
 *
 * [Documentation](https://docs.angularjs.org/api/ng/function/angular.toJson).
 *
 * @todo Update/depricated when AngularJs is no longer available.
 */
@Pipe({
  name: 'convertResourceToJson'
})
export class ConvertResourceToJsonPipe implements PipeTransform {

  /**
   * Convert Resource to Json and strip all $$ properties.
   */
  transform(resource: any): any {
    return JSON.parse(angular.toJson(resource));
  }

}
